import { WifiOff, RefreshCw } from 'lucide-react'

export function OfflinePage() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="text-center max-w-sm">
        <div className="w-16 h-16 rounded-2xl bg-navy-100 flex items-center justify-center mx-auto mb-4">
          <WifiOff className="w-8 h-8 text-navy-800" />
        </div>
        <h1 className="text-xl font-bold text-navy-800 mb-2">You're Offline</h1>
        <p className="text-gray-500 text-sm mb-6">
          Check your internet connection and try again. Some features may be available from cache.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="btn-primary inline-flex items-center gap-2"
        >
          <RefreshCw className="w-4 h-4" />
          Retry
        </button>
      </div>
    </div>
  )
}
